import JetSkiRichContent from "assets/images/psp/richconentImages/preparing-jet-ski-for-storage.webp";
import JetSkiRelatedContent from "assets/images/psp/relatedContentImages/jet-ski-storage.webp";
import GarageVsStorageRelatedContent from "assets/images/psp/relatedContentImages/garage-vs-storage.webp";
import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import illustrationSearch from "assets/images/psp/illustration-search.svg";
import HeaderBackgroundDesktop from "assets/images/psp/hero/jet-ski-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/jet-ski-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/jet-ski-header-tablet.webp";
import { storageCategories } from "../utils/getPSPLinks";

const reviews = {
	title: "Storage.com has 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "The person from Storage.com who assisted me was super helpful and offered several options. I saved a lot of money because of the great deals your company could offer, which were below market rate if I had dealt directly with the storage company.",
			author: "Pasadena Garden Club",
			title: "The person who assisted me was super…",
			imageSrc: GeorgeRansom
		},
		{
			body: "Abby, the customer service representative at storage.com, was professional, helpful and friendly. She found me a storage space at an excellent price in close proximity to my home. I can't thank her enough.",
			author: "Ann Alarcon",
			title: "A wonderful experience",
			imageSrc: AnnAlarcon
		},
		{
			body: "It was very easy to find storage close to me, and the selection was all mine. I was very happy with this process.",
			author: "Dale Howard",
			title: "Finding Storage",
			imageSrc: SMurphy
		}
	]
};

const faqs = [
	{
		question: "What size storage unit do I need for a jet ski?",
		answer: "A single jet ski on a trailer fits comfortably in a 10x10 storage unit, which Storage.com reports averages $97.40 monthly nationwide. For two jet skis or combined boat and jet ski storage, consider 10x20 units at $146.14/month average."
	},
	{
		question: "How much does jet ski storage cost during the off-season?",
		answer: "Storage.com's data shows enclosed 10x10 units average $97.40 and 10x15 units average $124.07 monthly. For a typical 6-month winter season, expect total costs of $450-$744."
	},
	{
		question: "Should I store my jet ski indoors or outdoors?",
		answer: "Indoor storage provides complete weather protection at Storage.com's average of $97.40 monthly for 10x10 units—only $20-$30 more than outdoor parking. For expensive PWCs or harsh climates, the small additional investment prevents costly damage."
	},
	{
		question: "Do I need to winterize my jet ski before storage?",
		answer: "Yes, proper winterization is essential regardless of storage type. Flush the cooling system, stabilize fuel, remove the battery, and protect against corrosion. Professional winterization costs $150-$300 but prevents $1,000+ in potential engine repairs."
	},
	{
		question: "Can I access my jet ski storage unit during winter?",
		answer: "Yes. Most facilities offer regular access during business hours (typically 6am-9pm daily). This allows you to check on your PWC, perform maintenance, or retrieve equipment during storage season without additional fees."
	},
	{
		question: "Is jet ski storage cheaper than marina storage?",
		answer: "Generally yes. Storage.com reports 10x10 units average $97.40 monthly and 10x15 units average $124.07, while marina wet slips or dry storage often cost $150-$400 monthly, depending on location and services, representing potential savings of $300-$1,800 per six-month season."
	},
	{
		question: "What's included in standard jet ski storage?",
		answer: "Standard units at $97.40-$146.14 monthly include enclosed protection, ground-level access, security features, and flexible month-to-month leases. Unlike specialty marina storage, you maintain complete access control without additional service fees or mandatory winterization charges."
	},
	{
		question: "How much does it cost to store multiple jet skis?",
		answer: "A 10x20 unit averaging $146.14/month can accommodate 2-3 jet skis. Split between three PWCs, that's approximately $49/month per jet ski—half the cost of individual 10x10 units and significantly cheaper than marina storage."
	}
];

const relatedContentCards = [
	{
		content:
			"Find the Best Jet Ski Storage: Safe and Flexible Options for Your Watercraft",
		category: "Recreational Storage",
		date: "August 13, 2025",
		url: "https://www.storage.com/blog/jet-ski-storage/",
		image: JetSkiRelatedContent
	},
	{
		content: "What Size Storage Unit for Your Car? A Comprehensive Guide",
		category: "Recreational Storage",
		date: "July 30, 2025",
		url: "https://www.storage.com/blog/car-storage-unit-size/",
		image: "https://www.storage.com/blog/wp-content/uploads/2024/10/car-storage-1-jpg.webp"
	},
	{
		content: "Garage vs Storage Unit: 5 Benefits of Self Storage",
		category: "Self Storage",
		date: "December 1, 2025",
		url: "https://www.storage.com/blog/garage-vs-storage-unit-5-benefits-of-self-storage/",
		image: GarageVsStorageRelatedContent
	}
];

const jetSkiHerodescription = `
Your jet ski was built to skip waves and give you thrills during the warmer months—but what happens when the leaves change and winter chills set in? [Winter weather threatens engines](https://www.storage.com/blog/boat-storage-guide/), UV rays fade hulls, and neighborhood parking rules create constant stress about where to keep your personal watercraft. Whether you need seasonal jet ski parking during off-months or year-round storage between weekend rides, professional storage facilities provide the secure, protected environment your PWC deserves. Storage.com connects you with verified jet ski storage facilities nationwide, offering both indoor and outdoor options designed specifically for personal watercraft.
`;

const howToStoreJetSkiContent = `
- **Vehicle Storage Spaces:**
  - Most budget-friendly option for jet ski parking.
  - Best in mild climates with quality PWC cover.
  - Requires proper winterization and secure tie-downs.
  - Saves approximately $20–$30 monthly compared to enclosed options.

- **10x10 Units:**
  - Provides complete enclosed protection for single jet skis (Storage.com national data).
  - Prevents weather damage and theft while offering ground-level drive-up access.
  - Only $22–$30 more monthly than outdoor parking, with significantly better protection.

- **10x15 Units:**
  - Offers extra room for maneuvering jet skis on trailers, plus storage for riding gear, life jackets, and maintenance equipment.
  - The additional $27/month over 10x10 units provides valuable convenience and organization space.

- **10x20 Units:**
  - Ideal for boat and jet ski storage combinations or multiple PWCs.
  - Accommodates 2–3 jet skis with room for accessories.
  - At approximately $49/month per jet ski when storing three units, this becomes very cost-effective.

- **Climate-Controlled Large Units:**
  - Climate-controlled options in this range prevent condensation damage in humid climates or extreme temperature swings.
  - Worth considering for newer, expensive PWCs or areas with severe winters.
`;

const richContentMarkdown = `
Proper storage preparation protects your jet ski investment:

1. **Before Storage:**

   a. Flush the cooling system with fresh water thoroughly \n\n 
   b. Add fuel stabilizer and fill the tank to prevent condensation\n\n  
   c. Remove the battery and store it separately, or connect it to a trickle charger\n\n  
   d. Clean the hull completely to prevent mold and oxidation\n\n  
   e. Apply corrosion inhibitor to metal components\n\n  

2. **During Storage:**

   a. Keep PWC covered even in indoor units to prevent dust accumulation\n\n  
   b. Check periodically if accessing the facility during the storage season\n\n  
   c. Ensure trailer tires remain properly inflated\n\n  

3. **Storage Facility Benefits:**

   a. Enclosed units starting at $97.40/month prevent moisture-related damage\n\n  
   b. Security systems protect against theft\n\n
   c. Ground-level access makes seasonal moving manageable\n\n  
   d. Affordable rates make professional jet ski garage storage accessible to most owners\n\n  
`;

const whatMakesJetSkiContent = `
- **Trailer-Friendly Access:**
  - Wide gates and drive aisles accommodate jet ski trailers of all sizes

- **Ground-Level Units:**
  - No ramps or lifts required — drive straight in with your towed PWC

- **Flexible Seasonal Leases:**
  - Month-to-month or seasonal contracts (6–8 months) without a year-long commitment.
  - Six-month winter storage costs approximately $584–$877, depending on unit size.

- **Security Features:**
  - [Gated access, video surveillance, and individual unit locks protect valuable watercraft](https://www.storage.com/blog/understanding-self-storage-security-features/)

- **Location Convenience:**
  - Many facilities are located near popular lakes and beaches for easy access

- **Multiple Unit Sizes:**
  - From 10×10 for single PWCs ($97.40/month) to 10×20+ for [boat and jet ski storage combinations](https://www.storage.com/blog/boat-storage-costs-complete-guide) ($146.14/month)

- **Cost-Effective Protection:**
  - At Storage.com's averages, six months of enclosed storage ($584 for 10x10) costs less than a single major engine repair from improper winterization
`;

export const PSPJetSkiContent = {
	type: "Jet Ski",
	pageType: "jet-ski",
	sections: [
		// ── 1. Hero Section ─────────────────────────
		{
			title: "Jet Ski Storage hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find the Top Jet Ski Storage Units",
						description: jetSkiHerodescription,
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find Jet Ski Storage",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "Jet Ski Storage Hero Image"
					}
				}
			]
		},

		// ── 2. Content Section ──────────────────────
		{
			title: "Understanding Jet Ski Storage Costs and Solutions",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Understanding Jet Ski Storage Costs and Solutions",
						content: [
							{
								id: "1",
								value: "When riding season ends, but your jet ski still needs somewhere to live for 6-8 months. [Garage space is precious](https://www.storage.com/blog/garage-vs-storage-unit-5-benefits-of-self-storage/), driveway storage looks bad and risks theft, and improper winterization leads to expensive engine repairs come spring."
							},
							{
								id: "2",
								value: "Wondering how to store a jet ski properly? Here's a tip: you don't have to build a specialty structure. Vehicle storage in our network typically costs $75-$110 monthly, while Storage.com reports that enclosed drive-up units range from $97.40 for 10x10 spaces to $146.14 monthly for 10x20 units—far less than engine repairs from improper storage or HOA fines from driveway parking."
							},
							{
								id: "3",
								value: "Boat and jet ski storage facilities solve these problems with flexible solutions designed for seasonal use. Instead of sacrificing your garage or worrying about weather damage, you get professional-grade storage that keeps your PWC in riding-ready condition."
							}
						],
						background: "white",
						isColumnWise: false
					}
				}
			]
		},

		// ── 3. Size Guide Table / Storage Size Chart - Cost ──
		{
			title: "Jet Ski Storage Size Chart",
			noPadding: true,
			modules: [
				{
					type: "size-chart",
					props: {
						pageType: "psp",
						background: "light-blue",
						title: "Jet Ski Storage Pricing Guide",
						description:
							"Use this simple pricing guide to figure out which jet ski storage solution fits your budget.",
						storages: [
							{
								title: "Vehicle Storage Spaces",
								numerics: ["$75-$110/month"],
								bestFor: [
									"Budget-conscious coverage, covered PWCs",
									"Mild climates"
								]
							},
							{
								title: "10×10",
								numerics: ["$95-$100/month"],
								bestFor: [
									"Single jet ski",
									"Basic weather protection"
								]
							},
							{
								title: "10×15",
								numerics: ["$124.07/month"],
								bestFor: [
									"Single jet ski with gear",
									"Extra maneuvering room"
								]
							},
							{
								title: "10×20",
								numerics: ["$146.14/month"],
								bestFor: ["Multiple jet skis", "Small boat"]
							}
						],
						postModuleDescription:
							"*All pricing from Storage.com national averages"
					}
				}
			]
		},

		// ── 4. Content Section 1 - single column ────
		{
			title: "Who Needs Jet Ski Storage?",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Who Needs Jet Ski Storage?",
						description:
							"Professional jet ski parking isn't just for seasonal storage. Here's how different PWC owners benefit from storage solutions:",
						listType: "single",
						content: [
							{
								id: "1",
								value: `- **Seasonal Riders**

	Winter storage (October-April in most climates), off-season protection from weather, and space reclamation in home garages.

- **Multiple Watercraft Owners**

	Storage for 2-3 jet skis or combined boat and jet ski storage, fleet parking for rental businesses, and family collections.

- **Urban & Condo Dwellers**

	No garage or driveway available, HOA-compliant storage solution, convenient location near launch ramps.

- **Winter Snowbirds**

	Secure storage while traveling south, protection from freezing temperatures, and year-round security monitoring.

- **Frequent Riders**

	Quick access between weekend trips, closer to the lake/beach than home, and avoiding constant trailer hitching.`
							}
						],
						background: "blue",
						isColumnWise: false
					}
				}
			]
		},

		// ── 5. Content Section 2 - single column ────
		{
			title: "How to Store a Jet Ski: Indoor vs. Outdoor Options",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "How to Store a Jet Ski: Indoor vs. Outdoor Options",
						description:
							"Choosing the right jet ski storage depends on your climate, budget, and storage duration:",
						content: [
							{
								id: "1",
								value: howToStoreJetSkiContent
							}
						],
						background: "light-blue",
						isColumnWise: false
					}
				}
			]
		},

		// ── 6. Rich Content Section ─────────────────
		{
			title: "Jet Ski Garage Storage: Preparing Your PWC for Storage",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "Jet Ski Garage Storage: Preparing Your PWC for Storage",
						description: "",
						mediaUrl: JetSkiRichContent,
						mediaType: "image",
						videoTitle: "",
						additionalContent: true,
						textAlign: "left",
						markDown: richContentMarkdown
					}
				}
			]
		},

		// ── 7. Content Section - single column ──────
		{
			title: "What Makes Jet Ski Storage Facilities Different",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "What Makes Jet Ski Storage Facilities Different",
						description:
							"Unlike residential garages, jet ski storage facilities offer specialized advantages:",
						content: [
							{
								id: "1",
								value: whatMakesJetSkiContent
							}
						],
						isColumnWise: false,
						background: "light-blue"
					}
				}
			]
		},

		// ── 8. Inline CTA ───────────────────────────
		{
			title: "Jet Ski Storage CTA",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "Jet Ski"
					}
				}
			]
		},

		// ── 9. Reviews ──────────────────────────────
		{
			title: "Jet Ski Storage Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviews
				}
			]
		},

		// ── 10. FAQs ────────────────────────────────
		{
			title: "Jet Ski Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "Jet Ski Storage FAQs",
						faqs
					}
				}
			]
		},

		// ── 11. Related Content ─────────────────────
		{
			title: "Jet Ski Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About Jet Ski Storage",
						unitCards: relatedContentCards
					}
				}
			]
		},

		// ── 12. Links to Other PSPs ─────────────────
		{
			title: "Links to other PSP",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						background: "white",
						storageGridContent: {
							title: "More Ways to Store",
							image: illustrationSearch,
							storageTypes: storageCategories.jetSki
						}
					}
				}
			]
		},

		// ── 13. Nearby Cities ───────────────────────
		{
			title: "Jet Ski Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						pageType: "PSP",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPJetSkiContent;
